export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.75 4A3.25 3.25 0 014 .75h14A3.25 3.25 0 0119.25 7v9A3.25 3.25 0 0116 19.25h-.5c-.7 0-1.2-.6-1.2-1.3 0-.6.5-1.2 1.2-1.2h.5a.75.75 0 00.75-.75V7.25H5.25V16c0 .414.336.75.75.75h.5c.7 0 1.2.6 1.2 1.2s-.5 1.3-1.2 1.3H6A3.25 3.25 0 012.75 16V7a3.251 3.251 0 01-2-3zM4 3.25a.75.75 0 000 1.5h14a.75.75 0 000-1.5H4zm5.75 15a1.25 1.25 0 102.5 0v-4.982l.866.866a1.25 1.25 0 001.768-1.768l-3-3a1.25 1.25 0 00-1.768 0l-3 3a1.25 1.25 0 001.768 1.768l.866-.866v4.982z\" fill=\"#9CA3AF\"/>",
  "attrs": {
    "viewBox": "0 0 22 20",
    "fill": "none"
  }
};